import type {
  CreateSupportLinkInput,
  SupportLinkDto,
  UpdateSupportLinkInput,
} from "@mvk/shared";
import { isApiEnabled } from "../api/config";
import { apiRequest } from "../api/client";
import { maxPlatform } from "./maxPlatform";

export const supportLinksService = {
  async listForEvent(eventId: string): Promise<SupportLinkDto[]> {
    if (!isApiEnabled()) return [];
    const data = await apiRequest<{ links: SupportLinkDto[] }>(
      `/events/${eventId}/support-links`,
    );
    return data.links;
  },

  async listForManage(eventId: string): Promise<SupportLinkDto[]> {
    const data = await apiRequest<{ links: SupportLinkDto[] }>(
      `/events/${eventId}/support-links?manage=true`,
      { audience: "admin" },
    );
    return data.links;
  },

  async create(eventId: string, input: CreateSupportLinkInput): Promise<SupportLinkDto> {
    const data = await apiRequest<{ link: SupportLinkDto }>(
      `/events/${eventId}/support-links`,
      { method: "POST", body: input, audience: "admin" },
    );
    return data.link;
  },

  async update(
    eventId: string,
    linkId: string,
    patch: UpdateSupportLinkInput,
  ): Promise<SupportLinkDto> {
    const data = await apiRequest<{ link: SupportLinkDto }>(
      `/events/${eventId}/support-links/${linkId}`,
      { method: "PATCH", body: patch, audience: "admin" },
    );
    return data.link;
  },

  async remove(eventId: string, linkId: string): Promise<void> {
    await apiRequest(`/events/${eventId}/support-links/${linkId}`, {
      method: "DELETE",
      audience: "admin",
    });
  },

  openLink(link: SupportLinkDto): void {
    maxPlatform.hapticFeedback("light");
    if (link.openMode === "same_tab") {
      window.location.href = link.url;
      return;
    }
    maxPlatform.openExternalLink(link.url);
  },
};

/** @deprecated use supportLinksService */
export const chatService = {
  listThreads: (eventId: string) => supportLinksService.listForEvent(eventId),
};
